import React, { Fragment, useState } from 'react'
import axios from 'axios'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Paper, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux'
import { actualizaCliente, actualizarDatosFilesCliente, actualizarFileCliente, actualizarFolioOficio, agregarFileCliente, agregarHistorialArchivosCliente, generarOficiosClienteConsulta, obtenerClienteConDetalle } from '../../../../../../redux/DucksAtencionACliente/ModuloConsultaDucks';
import moment from 'moment'
import estilos from '../../../TablaClientesComponent.module.css'

import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../../../../redux/AppDucks'
import { obtenerFolioConsulta } from '../../../../../../redux/DucksAtencionACliente/ModuloConsultaDucks';
function BotonGenerarOficiosComponent(props) {

    const dispatch = useDispatch()
    const dataUser = useSelector(store => store.Usuario.user)
    const detalleCliente = useSelector(store => store.ModuloConsulta.detalleCliente)
    const [openModalGenerarOficio, setOpenModalGenerarOficio] = React.useState(true);

    const [numeroDeCliente, setNumeroDeCliente] = useState(detalleCliente?.numerosocio);
    const [fechaEmision, setFechaEmision] = useState('');
    console.log('fechaEmision ', fechaEmision);
    const [tiposocio, setTipoSocio] = useState('');
    const [poderNotarial, setPoderNotarial] = useState('');

    const [datosDelActa, setdatosDelActa] = useState('');
    const [objetoSocial, setObjetoSocial] = useState('');
    const [tipoDeIdentificacion, setTipoDeIdentificacion] = useState('');
    const [otroTipoDeIdentificacion, setOtroTipoDeIdentificacion] = useState('');
    const [numeroDeIdentificacion, setNumeroDeIdentificacion] = useState('');
    const [emisionDeAcreditacion, setEmisionDeAcreditacion] = useState('');
    const [expedidoPor, setExpedidoPor] = useState('');
    const password = ''//data.passwordNom
    const [passwordNom, setPasswordNom] = useState('');

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        height: 'fit-content',
        bgcolor: 'background.paper',
        border: 'px solid #000',
        boxShadow: 24,
        p: 4,
        color: 'black',
        borderRadius: '5px'
    };

    const theme = createTheme({
        palette: {
            primary: {
                main: "#EDB75A"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });

    const handleCloseModal = async () => {
        setOpenModalGenerarOficio(false)
        props.setOpenModalGenerarOficio(false)
    }

    const generarArchivos = async () => {
        await dispatch(actualizarLoadingApp_true())
        if (props?.data?.nameDoc == 'Asignación de número de cliente') {
            const folioAsignacion = await dispatch(obtenerFolioConsulta(1))
            let cadenaProductiva = ''
            for (const i in detalleCliente?.actividadcliente) {
                if (Number(i) === 0) {
                    cadenaProductiva += detalleCliente?.actividadcliente[i]?.tipoactividad?.actividad
                } else if (Number(i) + Number(1) === detalleCliente?.actividadcliente.length) {
                    cadenaProductiva += ' y ' + detalleCliente?.actividadcliente?.[i]?.tipoactividad?.actividad
                } else {
                    cadenaProductiva += ', ' + detalleCliente?.actividadcliente?.[i]?.tipoactividad?.actividad
                }
            }
            let data = {
                nombreRazonSocial: detalleCliente?.nombrerazonsocial, numeroSocio: numeroDeCliente, representanteLegal: detalleCliente?.nombrerepresentantelegal,
                folioAsignacion: folioAsignacion.payload.folio, datosInscripcion: tiposocio, idCliente: detalleCliente?.idcliente, cadenaProductiva: cadenaProductiva,
                tipoSolicitud: props?.data?.nameDoc, personafisica: detalleCliente?.personafisica, personamoral: detalleCliente?.personamoral, idoficioscliente: props?.data?.idSolicitud,
            }
            await dispatch(generarOficiosClienteConsulta(data))
            await dispatch(actualizarFolioOficio({ idSolicitud: 1, folio: await cambiarFolio(folioAsignacion.payload.folio) }))

        }
        if (props?.data?.nameDoc == 'Contrato de prestación de servicios') {
            let cadenaProductiva = ''
            for (const i in detalleCliente?.actividadcliente) {
                if (Number(i) === 0) {
                    cadenaProductiva += detalleCliente?.actividadcliente[i]?.tipoactividad?.actividad
                } else if (Number(i) + Number(1) === detalleCliente?.actividadcliente.length) {
                    cadenaProductiva += ' y ' + detalleCliente?.actividadcliente?.[i]?.tipoactividad?.actividad
                } else {
                    cadenaProductiva += ', ' + detalleCliente?.actividadcliente?.[i]?.tipoactividad?.actividad
                }
            }
            let domicilioPrincipal = detalleCliente?.domiciliofiscalcliente?.filter(domicilio => domicilio.domicilioprincipal == true && domicilio?.isbaja == false)
            const domicilioFiscal = domicilioPrincipal?.[0]?.calle + ", " + (domicilioPrincipal?.[0]?.numerointerior !== null ? domicilioPrincipal?.[0]?.numerointerior : 's/n') + ', ' +
                (domicilioPrincipal?.[0]?.numeroexterior !== null ? domicilioPrincipal?.[0]?.numeroexterior : 's/n') + ', '
                + domicilioPrincipal?.[0]?.colonia + ', ' + domicilioPrincipal?.[0]?.localidad + ', ' + domicilioPrincipal?.[0]?.municipioalcaldia + ', '
                + domicilioPrincipal?.[0]?.estado + ', C.P. ' + domicilioPrincipal?.[0]?.codigopostal

            let telefonos = detalleCliente.telefono + " " + detalleCliente.telefonorepresentante
            for (const i in detalleCliente?.mediosdecontactocliente) {
                if (detalleCliente?.mediosdecontactocliente?.[i].isbaja == false) telefonos += ' ' + detalleCliente?.mediosdecontactocliente?.[i]?.telefono
            }
            let nombrerepresentantelegal = ''
            if (detalleCliente.nombrerepresentantelegal != undefined && detalleCliente.nombrerepresentantelegal != '' && detalleCliente.nombrerepresentantelegal != null) {
                nombrerepresentantelegal = (detalleCliente.nombrerepresentantelegal).toUpperCase()
            } else {
                nombrerepresentantelegal = detalleCliente.nombrerazonsocial.toUpperCase()
            }
            let data = {
                nombreRazonSocial: detalleCliente?.nombrerazonsocial, numeroSocio: numeroDeCliente, representanteLegal: nombrerepresentantelegal,
                datosInscripcion: tiposocio, idCliente: detalleCliente?.idcliente, cadenaProductiva: cadenaProductiva,
                tipoIdentificacion: tipoDeIdentificacion, numeroIdentificacion: numeroDeIdentificacion, emisionDeAcreditacion: emisionDeAcreditacion, datosDelActa: datosDelActa,
                objetoSocial: objetoSocial, domicilioFiscal: domicilioFiscal.toUpperCase(), telefonos: telefonos, poderNotarial: poderNotarial,
                tipoSolicitud: props?.data?.nameDoc, personafisica: detalleCliente?.personafisica, personamoral: detalleCliente?.personamoral,
                idoficioscliente: props?.data?.idSolicitud, fechaEmision: new Date(fechaEmision).toISOString()
            }
            // console.log(data);
            await dispatch(generarOficiosClienteConsulta(data))
        }
        if (props?.data?.nameDoc == 'Contraseña oficial NOM') {
            const folioAsignacion = await dispatch(obtenerFolioConsulta(3))
            let cadenaProductiva = ''
            for (const i in detalleCliente?.actividadcliente) {
                if (Number(i) === 0) {
                    cadenaProductiva += detalleCliente?.actividadcliente[i]?.tipoactividad?.actividad
                } else if (Number(i) + Number(1) === detalleCliente?.actividadcliente.length) {
                    cadenaProductiva += ' y ' + detalleCliente?.actividadcliente?.[i]?.tipoactividad?.actividad
                } else {
                    cadenaProductiva += ', ' + detalleCliente?.actividadcliente?.[i]?.tipoactividad?.actividad
                }
            }
            let data = {
                nombreRazonSocial: detalleCliente?.nombrerazonsocial, numeroSocio: numeroDeCliente, representanteLegal: detalleCliente?.nombrerepresentantelegal, password: passwordNom,
                folioPasswordNom: folioAsignacion.payload.folio, datosInscripcion: tiposocio, idCliente: detalleCliente?.idcliente, cadenaProductiva: cadenaProductiva,
                tipoSolicitud: props?.data?.nameDoc, personafisica: detalleCliente?.personafisica, personamoral: detalleCliente?.personamoral, idoficioscliente: props?.data?.idSolicitud
            }
            await dispatch(generarOficiosClienteConsulta(data))
            await dispatch(actualizarFolioOficio({ idSolicitud: 3, folio: await cambiarFolio(folioAsignacion.payload.folio) }))
        }

        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechahistorial = new Date(fechaHoy).toISOString()
        const dataHistorial = {
            usuario: dataUser?.[0]?.usuario, fecha: fechahistorial, nombrearchivo: 'Se generó nuevo Formato',
            idarchivo: props?.data?.idSolicitud, tabla: props?.data?.tabla
        }
        await dispatch(agregarHistorialArchivosCliente(dataHistorial))

        await dispatch(actualizarLoadingApp_false())
        props.setOpenModalGenerarOficio(false)
        //await dispatch(obtenerClienteConDetalle(props?.idcliente))
    }
    const cambiarFolio = async (folio) => {
        const nuevoFolio = ('000' + (parseInt(folio, 10) + 1)).slice(-4)
        return nuevoFolio
    }

    return (
        <Fragment>
            <Modal
                open={openModalGenerarOficio}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description" >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h5" sx={{ mt: 0, fontFamily: 'Montserrat', textAlign: 'center', fontWeight: 'bold' }}>
                        Generar Oficio {props?.data?.nameDoc}
                    </Typography>
                    <Typography id="modal-modal-description" component="h5" sx={{ mt: 3, fontFamily: 'Montserrat' }} className='text-center'>
                        {detalleCliente.personafisica == true ?
                            <Fragment>
                                {props?.data?.nameDoc == 'Asignación de número de cliente' &&
                                    <Fragment>
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setNumeroDeCliente(e.target.value)}
                                                value={numeroDeCliente}
                                                placeholder='Número de Asociado' />
                                            <label className="floatingInput">Número de Asociado</label>
                                        </div>
                                        <div className={`form-floating mb-2 ${'col-md-12'}`}>
                                            <div className="form-floating mb-3">
                                                <select className={`form-control`}
                                                    value={tiposocio}
                                                    onChange={e => setTipoSocio(e.target.value)}
                                                    id="floatingInput" >
                                                    <option value="">Seleccione una opción</option>
                                                    <option value={`Asociado`}>Asociado</option>
                                                    <option value={`No Asociado`}>No Asociado</option>
                                                    <option value={`Inscrito`}>Inscrito</option>
                                                </select>
                                                <label className="floatingInput">Tipo de socio</label>
                                            </div>
                                        </div>
                                    </Fragment>
                                }
                                {props?.data?.nameDoc == 'Contrato de prestación de servicios' &&
                                    <Fragment>
                                        <div className="form-floating mb-3">
                                            <input type="date" id="floatingInput" className={`form-control`}
                                                onChange={e => setFechaEmision(e.target.value)}
                                                value={fechaEmision}
                                                placeholder='Número de Asociado' />
                                            <label className="floatingInput">Fecha de Emisión</label>
                                        </div>
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setNumeroDeCliente(e.target.value)}
                                                value={numeroDeCliente}
                                                placeholder='Número de Asociado' />
                                            <label className="floatingInput">Número de Asociado</label>
                                        </div>
                                        <div className={`form-floating mb-2 ${tipoDeIdentificacion === 'OTRO' ? 'col-md-6' : 'col-md-12'}`}>
                                            <div className="form-floating mb-3">
                                                <select className={`form-control`}
                                                    value={tipoDeIdentificacion}
                                                    onChange={e => setTipoDeIdentificacion(e.target.value)}
                                                    id="floatingInput" >
                                                    <option value="">Seleccione una opción</option>
                                                    <option value={`INE`}>INE</option>
                                                    <option value={`IFE`}>IFE</option>
                                                    <option value={`PASAPORTE`}>PASAPORTE</option>
                                                    <option value={`CÉDULA PROFESIONAL`}>CÉDULA PROFESIONAL</option>
                                                    <option value={`OTRO`}>OTRO</option>
                                                </select>
                                                <label className="floatingInput">Tipo de identificación</label>
                                            </div>
                                        </div>
                                        {tipoDeIdentificacion === 'OTRO' &&
                                            <div className='col-md-6'>
                                                <div className="form-floating mb-2">
                                                    <input type="text" className={`form-control`}
                                                        onChange={e => setOtroTipoDeIdentificacion(e.target.value)}
                                                        value={otroTipoDeIdentificacion}
                                                        id="" />
                                                    <label className="floatingInput">Especifique</label>
                                                </div>
                                            </div>
                                        }
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setNumeroDeIdentificacion(e.target.value)}
                                                value={numeroDeIdentificacion}
                                                placeholder='Número de Identificación' />
                                            <label className="floatingInput">Número de identificación</label>
                                        </div>
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setEmisionDeAcreditacion(e.target.value)}
                                                value={emisionDeAcreditacion}
                                                placeholder='Número de Identificación' />
                                            <label className="floatingInput">Emisión de acreditación</label>
                                        </div>
                                    </Fragment>
                                }
                                {props?.data?.nameDoc == 'Contraseña oficial NOM' &&
                                    <div className="form-floating mb-3">
                                        <input type="text" id="floatingInput" className={`form-control`}
                                            onChange={e => setPasswordNom(e.target.value)}
                                            value={passwordNom}
                                            placeholder='Contraseña NOM' />
                                        <label className="floatingInput">Contraseña NOM</label>
                                    </div>
                                }
                            </Fragment>
                            :
                            <Fragment>
                                {props?.data?.nameDoc == 'Asignación de número de cliente' &&
                                    <Fragment>
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setNumeroDeCliente(e.target.value)}
                                                value={numeroDeCliente}
                                                placeholder='Número de Asociado' />
                                            <label className="floatingInput">Número de Asociado</label>
                                        </div>

                                        <div className={`form-floating mb-2 ${'col-md-12'}`}>
                                            <div className="form-floating mb-3">
                                                <select className={`form-control`}
                                                    value={tiposocio}
                                                    onChange={e => setTipoSocio(e.target.value)}
                                                    id="floatingInput" >
                                                    <option value="">Seleccione una opción</option>
                                                    <option value={`Asociado`}>Asociado</option>
                                                    <option value={`No Asociado`}>No Asociado</option>
                                                    <option value={`Inscrito`}>Inscrito</option>
                                                </select>
                                                <label className="floatingInput">Tipo de socio</label>
                                            </div>
                                        </div>*
                                    </Fragment>
                                }
                                {props?.data?.nameDoc == 'Contrato de prestación de servicios' &&
                                    <Fragment>
                                        <div className="form-floating mb-3">
                                            <input type="date" id="floatingInput" className={`form-control`}
                                                onChange={e => setFechaEmision(e.target.value)}
                                                value={fechaEmision}
                                                placeholder='Número de Asociado' />
                                            <label className="floatingInput">Fecha de Emisión</label>
                                        </div>
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setNumeroDeCliente(e.target.value)}
                                                value={numeroDeCliente}
                                                placeholder='Número de Asociado' />
                                            <label className="floatingInput">Número de Asociado</label>
                                        </div>
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setPoderNotarial(e.target.value)}
                                                value={poderNotarial}
                                                placeholder='Poder Notarial' />
                                            <label className="floatingInput">Poder notarial</label>
                                        </div>
                                        {/*<div className='row justify-content-center'>
                                            <div className={`${tipoDeIdentificacion === 'OTRO' ? 'col-md-6' : 'col-md-12'}`}>
                                                <div className="form-floating mb-3">
                                                    <select className={`form-control`}
                                                        value={tipoDeIdentificacion}
                                                        onChange={e => setTipoDeIdentificacion(e.target.value)}
                                                        id="floatingInput" >
                                                        <option value="">Seleccione una opción</option>
                                                        <option value={`INE`}>INE</option>
                                                        <option value={`IFE`}>IFE</option>
                                                        <option value={`PASAPORTE`}>PASAPORTE</option>
                                                        <option value={`CÉDULA PROFESIONAL`}>CÉDULA PROFESIONAL</option>
                                                        <option value={`OTRO`}>OTRO</option>
                                                    </select>
                                                    <label className="floatingInput">Tipo de identificación</label>
                                                </div>
                                            </div>
                                            {tipoDeIdentificacion === 'OTRO' &&
                                                <div className='col-md-6'>
                                                    <div className="form-floating mb-2">
                                                        <input type="text" className={`form-control`}
                                                            onChange={e => setOtroTipoDeIdentificacion(e.target.value)}
                                                            value={otroTipoDeIdentificacion}
                                                            id="" />
                                                        <label className="floatingInput">Especifique</label>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setNumeroDeIdentificacion(e.target.value)}
                                                value={numeroDeIdentificacion}
                                                placeholder='Número de Identificación' />
                                            <label className="floatingInput">Número de identificación</label>
                                        </div>
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setEmisionDeAcreditacion(e.target.value)}
                                                value={emisionDeAcreditacion}
                                                placeholder='Número de Identificación' />
                                            <label className="floatingInput">Emisión de acreditación</label>
                                        </div>*/}
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setdatosDelActa(e.target.value)}
                                                value={datosDelActa}
                                                placeholder='Datos del Acta Constitutiva' />
                                            <label className="floatingInput">Datos del Acta Constitutiva</label>
                                        </div>
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setObjetoSocial(e.target.value)}
                                                value={objetoSocial}
                                                placeholder='Objeto Social' />
                                            <label className="floatingInput">Objeto Social</label>
                                        </div>
                                    </Fragment>
                                }
                                {props?.data?.nameDoc == 'Contraseña oficial NOM' &&
                                    <div className="form-floating mb-3">
                                        <input type="text" id="floatingInput" className={`form-control`}
                                            onChange={e => setPasswordNom(e.target.value)}
                                            value={passwordNom}
                                            placeholder='Contraseña NOM' />
                                        <label className="floatingInput">Contraseña NOM</label>
                                    </div>
                                }
                            </Fragment>
                        }
                    </Typography>
                    <ThemeProvider theme={theme}>

                        <div className='row mt-5'>
                            <div className='col-6 col-md-6'>
                                <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => { handleCloseModal() }}>Cancelar</Button>
                            </div>
                            <div className='col-6 col-md-6'>
                                <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => { generarArchivos() }}>Generar Oficios</Button>
                            </div>
                        </div>
                    </ThemeProvider>
                </Box>
            </Modal>
        </Fragment>
    )
}

export default BotonGenerarOficiosComponent